import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {
	Playlist,
	PlaylistFansEvolution,
	PlaylistFilterArtistNames,
	PlaylistFilterPlaylistNames,
	PlaylistFilterSegmentations,
	PlaylistReport,
} from './types';
import type {
	DataResponseWrapper,
	PaginationMeta,
} from '@deezer/next/services/api/Starmania/requests/types';
import {StakeholderType} from '@deezer/next/contexts/main/types';

const {get, paginatedGet} = requestWrapper;

const requests = {
	get: (id: string) =>
		get<DataResponseWrapper<Playlist>>(endpoints.playlistById(id)),
	getFans: (id: string, startDate: string, endDate: string) =>
		get<DataResponseWrapper<PlaylistFansEvolution | null>>(
			endpoints.playlistFans(id),
			{
				params: {
					startDate,
					endDate,
				},
			},
		),
	getReport: (filters?: {
		artistId?: string;
		playlistId?: string;
		country: string;
		editorSeg: string;
		stakeholderId: number | null;
		stakeholderType:
			StakeholderType.PROVIDER | StakeholderType.LABEL_GROUP | null;
	}) =>
		paginatedGet<PlaylistReport, PaginationMeta>(endpoints.report, {
			params: {
				artistId: filters?.artistId || undefined,
				playlistId: filters?.playlistId || undefined,
				editorSeg:
					!filters?.editorSeg || filters.editorSeg === 'All'
						? undefined
						: filters.editorSeg.toLocaleLowerCase(),
				country:
					!filters?.country || filters?.country === 'WW'
						? undefined
						: filters.country,
				stakeholderType: filters?.stakeholderType || undefined,
				providerId:
					filters?.stakeholderType === StakeholderType.PROVIDER &&
					filters?.stakeholderId
						? filters?.stakeholderId
						: undefined,
				labelId:
					filters?.stakeholderType === StakeholderType.LABEL_GROUP &&
					filters?.stakeholderId
						? filters?.stakeholderId
						: undefined,
			},
		}),
	getReportExport: (filters?: {
		artistId?: string;
		playlistId?: string;
		country: string;
		editorSeg: string;
		stakeholderId: number | null;
		stakeholderType:
			StakeholderType.PROVIDER | StakeholderType.LABEL_GROUP | null;
	}) =>
		get<string>(endpoints.reportExport, {
			params: {
				artistId: filters?.artistId || undefined,
				playlistId: filters?.playlistId || undefined,
				editorSeg:
					!filters?.editorSeg || filters.editorSeg === 'All'
						? undefined
						: filters.editorSeg.toLocaleLowerCase(),
				country:
					!filters?.country || filters?.country === 'WW'
						? undefined
						: filters.country,
				stakeholderType: filters?.stakeholderType || undefined,
				providerId:
					filters?.stakeholderType === StakeholderType.PROVIDER &&
					filters?.stakeholderId
						? filters?.stakeholderId
						: undefined,
				labelId:
					filters?.stakeholderType === StakeholderType.LABEL_GROUP &&
					filters?.stakeholderId
						? filters?.stakeholderId
						: undefined,
			},
		}),
	getPlaylistFilterPlaylistNames: (
		stakeholderType:
			StakeholderType.PROVIDER | StakeholderType.LABEL_GROUP | null | undefined,
		stakeholderId: number | null | undefined,
	) =>
		get<DataResponseWrapper<PlaylistFilterPlaylistNames[]>>(
			endpoints.filtersPlaylistNames,
			{
				params: {
					providerId:
						stakeholderType === StakeholderType.PROVIDER && stakeholderId
							? stakeholderId
							: undefined,
					labelId:
						stakeholderType === StakeholderType.LABEL_GROUP && stakeholderId
							? stakeholderId
							: undefined,
				},
			},
		),
	getPlaylistFilterArtistNames: (
		stakeholderType:
			StakeholderType.PROVIDER | StakeholderType.LABEL_GROUP | null | undefined,
		stakeholderId: number | null | undefined,
	) =>
		get<DataResponseWrapper<PlaylistFilterArtistNames[]>>(
			endpoints.filtersPlaylistArtists,
			{
				params: {
					providerId:
						stakeholderType === StakeholderType.PROVIDER && stakeholderId
							? stakeholderId
							: undefined,
					labelId:
						stakeholderType === StakeholderType.LABEL_GROUP && stakeholderId
							? stakeholderId
							: undefined,
				},
			},
		),
	getPlaylistFilterSegmentations: () =>
		get<DataResponseWrapper<PlaylistFilterSegmentations>>(
			endpoints.filtersPlaylistSegmentations,
		),
};

export default requests;
